import { Tooltip, Popover, Autocomplete, TextField } from '@mui/material';
import { TableIconButton } from '../../../components/Styled';
import styles from './header.module.scss';
import { getAllStoreNames, StoreUtils } from '../../../utils/util';
import Icon from '../../../components/FormControl/Icon';
import { useAppContext } from '../../../contexts/AppContext';
import { sessionStore } from '../../../services/browserStorage';
import { FC, SyntheticEvent, useEffect, useState } from 'react';

const ShopSection: FC<{ onIdxChange: (idx: number) => void }> = ({ onIdxChange }) => {
  const { pageLoading } = useAppContext();

  const [listOfCompanies, setListOfCompanies] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [inputValue, setInputValue] = useState('');

  const getActiveStoreName = () =>
    StoreUtils.getKeyFromActiveSession(['userData', 'company']) || '';

  useEffect(() => {
    setListOfCompanies(getAllStoreNames());
  }, []);

  const handleSessionChange = async (_event: SyntheticEvent | null, value: string | null) => {
    if (value) {
      const index = listOfCompanies.indexOf(value);
      if (index !== -1) {
        pageLoading.show();
        setAnchorEl(null);
        StoreUtils.changeActiveSession(index);
        sessionStore.set('isStoreChange', true);
        setAnchorEl(null);
        onIdxChange(index);
        pageLoading.hide();
      }
    }
  };

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setInputValue('');
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title={'Change Shop'} placement='right'>
        <TableIconButton onClick={handleButtonClick} className={styles.shopButton}>
          <p className={styles.companyName}>{getActiveStoreName()}</p>
          <Icon icon={'ri-arrow-down-s-fill'} size={'1.2rem'} />
        </TableIconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        disableAutoFocus
      >
        <div style={{ padding: 16, minWidth: 250 }}>
          <Autocomplete
            options={listOfCompanies}
            value={getActiveStoreName()}
            onChange={handleSessionChange}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label='Select Store' variant='standard' />
            )}
          />
        </div>
      </Popover>
    </>
  );
};

export default ShopSection;
